function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 13h2v2H9zm0-8h2v6H9zm.99-5C4.47 0 0 4.48 0 10s4.47 10 9.99 10C15.52 20 20 15.52 20 10S15.52 0 9.99 0zM10 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
  fill: "currentColor"
});

function SvgIconExclaim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTkgMTNoMnYyaC0yem0wLThoMnY2aC0yem0uOTktNWMtNS41MiAwLTkuOTkgNC40OC05Ljk5IDEwczQuNDcgMTAgOS45OSAxMGM1LjUzIDAgMTAuMDEtNC40OCAxMC4wMS0xMHMtNC40OC0xMC0xMC4wMS0xMHptLjAxIDE4Yy00LjQyIDAtOC0zLjU4LTgtOHMzLjU4LTggOC04IDggMy41OCA4IDgtMy41OCA4LTggOHoiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz48L3N2Zz4K";
export { SvgIconExclaim as ReactComponent };